import React from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";

const AuthSplash = ({ label = "Loading..." }) => (
  <Backdrop
    open
    sx={{
      backgroundColor: "#222831",
      color: "#fff",
      zIndex: (theme) => theme.zIndex.drawer + 1,
    }}
  >
    <CircularProgress />
    <Typography sx={{ ml: 2 }}>{label}</Typography>
  </Backdrop>
);

export default AuthSplash;
